// extracted by mini-css-extract-plugin
export var fadeInOut = "_3m-3";
export var icon = "_3m-4";
export var savedIndicator = "_3m-2";
export var savingIndicator = "_3m-0";
export var spin = "_3m-1";